import { observer } from 'mobx-react-lite'
import { type CancelUserTransactionDialogViewModel } from '@/features/payouts/admin/review/CancelUserTransactionDialogViewModel'
import { CancelUserTransactionModal } from '@/features/payouts/admin/review/components/CancelUserTransactionModal'

export interface CancelUserTransactionModalContainerProps {
  vm: CancelUserTransactionDialogViewModel
}

export const CancelUserTransactionModalContainer = observer(
  function CancelUserTransactionModalContainer({
    vm,
  }: CancelUserTransactionModalContainerProps) {
    return (
      <CancelUserTransactionModal
        showing={vm.modal.showing}
        onClose={vm.modal.close}
        transactionShortId={vm.transactionShortId}
        isCancelPending={vm.cancelTransaction.pending}
        onCancelTransaction={vm.cancelTransaction}
        error={vm.cancelTransaction.error}
      />
    )
  },
)
